// React
import React, { useState, useEffect, useContext, useRef } from "react";
// React
// CSS
import styles from "./WalletModal.module.css";
// CSS
// Contexts
import { UserTokenContext } from "../../../../Contexts/userToken";
import HelperHeader from "../../../../Utils/HelperHeader/HelperHeader";
import { addAmountToUserBalance } from "../../../../Services/Profile/post/addAmountToUserBalance";
import Spinner from "../../../../Utils/Spinner/Spinner";
import Swal from "sweetalert2";
import { toast } from "react-toastify";
// Contexts
// Services
// Services

type WalletModalProps = {
  setIsModalInScreen: React.Dispatch<React.SetStateAction<boolean>>;
};

const WalletModal: React.FunctionComponent<WalletModalProps> = ({
  setIsModalInScreen,
}) => {
  const [inputValue, setInputValue] = useState<string | number>("");
  //
  const [isPending, setIsPending] = useState<boolean>(false);
  //
  const userToken = useContext(UserTokenContext);
  //
  const buttonRef = useRef<any>(null);
  //
  const modalContainerRef = useRef<HTMLDivElement>(null);
  //
  const innerContentsRef = useRef<HTMLDivElement>(null);
  //
  const [currentStatus, setCrrentStatus] = useState("تایید و پرداخت");

  const resizer = (e: React.MouseEvent | React.TouchEvent) => {
    e.currentTarget.classList.add(styles.little);
    buttonRef.current = e.currentTarget;
    setTimeout(() => {
      buttonRef.current.classList.remove(styles.little);
      buttonRef.current = null;
    }, 50);
  };
  //

  useEffect(() => {
    setTimeout(() => {
      if (!modalContainerRef.current) return;
      modalContainerRef.current.style.opacity = "1";
      setTimeout(() => {
        if (!innerContentsRef.current) return;
        innerContentsRef.current.style.top = "0%";
      }, 100);
    }, 100);
  }, []);

  return (
    <div
      className={`${
        styles.walletModalContainer
      } w-screen h-screen fixed top-0 ${
        window.innerWidth > 600 ? "-mr-11" : "left-0"
      } flex items-center justify-center`}
      ref={modalContainerRef}
    >
      <div
        className={`${styles.outer} `}
        onClick={() => {
          if (!innerContentsRef.current) return;
          innerContentsRef.current.style.top = "-80%";
          setTimeout(() => {
            if (!modalContainerRef.current) return;
            modalContainerRef.current.style.opacity = "0";
            setTimeout(() => {
              setIsModalInScreen(false);
            }, 100);
          }, 400);
        }}
      ></div>
      <div
        className={`${styles.inner} w-full pb-4 pt-8 bg-white px-4 `}
        ref={innerContentsRef}
      >
        <HelperHeader absoluteText="افزایـــش اعــتبار" isBgWhite={true} />
        <input
          type="number"
          onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
            setInputValue(e.target.valueAsNumber);
          }}
          className="w-full bg-transparent mt-8"
          placeholder="مبلغ مورد نظر به تومان"
          value={inputValue}
        />
        <div
          className={`${styles.buttonContainer} flex flex-row items-center justify-between mt-8`}
        >
          <button
            onClick={(e) => {
              setInputValue(100000);
              resizer(e);
            }}
          >
            <span className="w-full text-center">100,000</span>
            <span className="w-full text-center">تومان</span>
          </button>
          <button
            onClick={(e) => {
              resizer(e);
              setInputValue(200000);
            }}
          >
            <span className="w-full text-center">200,000</span>
            <span className="w-full text-center">تومان</span>
          </button>
          <button
            onClick={(e) => {
              resizer(e);
              setInputValue(500000);
            }}
          >
            <span className="w-full text-center">500,000</span>
            <span className="w-full text-center">تومان</span>
          </button>
        </div>
        {/*  */}
        {/*  */}
        {/*  */}
        {/*  */}
        {/*  */}
        {/*  */}
        <button
          onClick={() => {
            if (isPending) return;
            if (Number(inputValue) < 1000) {
              Swal.fire({
                icon: "error",
                title: "حداقل مبلغ واریزی یک هزار تومان است",
              });
              return;
            }
            setIsPending(true);
            addAmountToUserBalance(userToken, Number(inputValue))
              .then(({ data: { url } }) => {
                setCrrentStatus("در حال ارسال به درگاه");
                window.location.href = url;

                setIsPending(false);
              })
              .catch((err) => {
                console.log(err);
                setIsPending(false);
                toast(
                  err.response.data.message
                    ? err.response.data.message
                    : err.message
                );
              });
          }}
          className={`${styles.submitBtn} w-full py-3 font-bold text-white mt-6 rounded-lg relative flex items-center justify-center `}
        >
          {isPending ? (
            <>
              <Spinner />
            </>
          ) : (
            <>{currentStatus}</>
          )}
        </button>
      </div>
    </div>
  );
};

export default WalletModal;
